/* eslint-disable eqeqeq */
<template>
<div>
  <VueFullScreenFileDrop @drop="OnDrop" v-if="!upload && !isLoadingDialog">
    <div class='custom-content' style="color:primary">
        Отпустите для загрузки отчета
      </div>
  </VueFullScreenFileDrop>
  <report-load-form :dialog="isLoadingDialog" v-on:onDialogClosed="onLoadDialogClosed"></report-load-form>
  <report-drag-and-drop :loaderActive="upload" :file="uploadFile"></report-drag-and-drop>
  <v-card class="fill-height" height="100%">
    <v-toolbar
      flat
      height="auto"
      class="elevation-5"
    >
      <v-toolbar-title style="width:100%;">
        <v-row>
          <v-col lg="5" md="5" sm="5" cols="12" xl="5">
            <h4>Рабочий стол</h4>
          </v-col>
          <v-col lg="7" xl="7" md="7" sm="7" cols="12">
            <v-select
              dense
              @change="onCardSystemChanged"
              :disabled="transactionsLoading"
              solo
              full-width
              v-model="cardSystem"
              :items="cardSystems"
              label="Система ТК"
              required
              >
            </v-select>
          </v-col>
        </v-row>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text style="padding:0px;" >
      <v-row class="mx-auto my-0 elevation-12" justify="end">
        <v-col lg="4" offset-lg="1" cols="12" style="text-align: center; vertical-align: middle; height:100%;"><p class="font-weight-black text-h4">{{mainDateText}}</p></v-col>
        <v-col class="my-0">
          <v-btn :disabled="transactionsLoading"  @click="PrevMonth" block color="primary" x-large>
          <v-icon x-large class="pr-2 pl-0" left>mdi-code-less-than</v-icon>
          Предыдущий месяц
          </v-btn></v-col>
        <v-col class="my-0">
          <v-btn :disabled="transactionsLoading" @click="NextMonth" block color="primary" x-large>
            Следующий месяц
            <v-icon right x-large class="pl-2 pr-0">mdi-code-greater-than</v-icon>
            </v-btn>
            </v-col>
      </v-row>

      <div class="container-fluid">
        <v-row justify="center" align="center" v-if="!transactionsLoading">
          <v-col cols="12" sm="12" md="3" xl="3" lg="3">
            <h2 class="font-weight-black" align="center">{{transactionFuelSummay}} л.</h2>
            <h4 class="text--disabled" align="center">Приобретено в этом месяце</h4>
          </v-col>
          <v-col cols="12" sm="12" md="3" xl="3" lg="3">
            <h2 class="font-weight-black" align="center">{{transactionMoneySummay}} руб.</h2>
            <h4 class="text--disabled" align="center">Потрачено в этом месяце</h4>
          </v-col>
          <v-col cols="12" sm="12" md="3" xl="3" lg="3">
            <h2 class="font-weight-black" align="center">{{topMark}}</h2>
            <h4 class="text--disabled" align="center">Самая используемая марка топлива</h4>
          </v-col>
        </v-row>
        <v-row class="px-1">
          <v-col xl="9" sm="12" cols="12" lg="9" md="12">
            <v-row class="mb-2 pa-1 pr-2"><RateBarChart/></v-row>
            <v-row class="pa-1 pr-2 mb-9"><TransactionsBarChart/></v-row>
            <v-row class="mt-2 pa-1 mt-2 pr-2 table-container" style="width:100%;">
              <v-data-table
              v-if="transactionDayList.length > 0"
              class="ma-0"
              :headers="headers"
              :items="transactionDayList"
              style="width:100%"
              >
              <template v-slot:item.transactionDateTime="{ item }">
            {{new Date(item.transactionDateTime).toLocaleDateString('ru-RU', {month:'short', day:'numeric', year:'2-digit', hour:'2-digit', minute:'2-digit'})}}
          </template>
              </v-data-table>
                <!-- <v-simple-table dense v-if="transactionDayList.length > 0" fixed-header class="ma-0" style="width:100%">
                  <thead>
                  <tr>
                    <th class="text-left">Дата/Время</th>
                    <th class="text-left">Номер карты</th>
                    <th class="text-left">Бренд АЗС</th>
                    <th class="text-left">Марка</th>
                    <th class="text-left">Заправлено</th>
                    <th class="text-left">Сумма</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in transactionDayList" :key="item.id" class="endline">
                    <td data-label="Дата/ Время" style="" class="text-left">{{ new Date(item.transactionDateTime).toLocaleString('ru',{year: 'numeric', month: 'numeric', day: 'numeric',  hour: 'numeric', minute: 'numeric' }) }}</td>
                    <td data-label="Номер карты" class="text-left">{{ item.cardNumber }}</td>
                    <td data-label="Бренд АЗС" class="text-left">{{ item.brand }}</td>
                    <td data-label="Марка" class="text-left">{{ item.serviceType }}</td>
                    <td data-label="Заправлено" class="text-left">{{ item.value }} л.</td>
                    <td data-label="Сумма" style="" class="text-left">{{ item.sum }} ₽</td>
                  </tr>
                  <tr></tr>
                  </tbody>
                </v-simple-table> -->
            </v-row>
          </v-col>
          <v-col xl="3" sm="12" cols="12" lg="3" md="12">
            <v-row style="height:100%;" class="mb-2 pa-1 pr-2"><StatisticBar/></v-row>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TransactionsBarChart from '../components/TransactionsBarChart'
import RateBarChart from '../components/RateBarChart'
import StatisticBar from '../components/StatisticBar'
import ReportDragAndDrop from '../components/ReportDragAndDrop'
import ReportLoadForm from '../components/ReportLoadForm'
import VueFullScreenFileDrop from 'vue-full-screen-file-drop'
import 'vue-full-screen-file-drop/dist/vue-full-screen-file-drop.css'

export default {
  computed: {
    ...mapState({
      user: state => state.users.user,
      transactions: state => state.transactions.transactions,
      transactionDayList: state => state.transactions.dayStatusTransactions,
      transactionsLoading: state => state.transactions.transactionsLoading,
      upload: state => state.transactions.upload
    }),
    transactionFuelSummay: function () {
      if (this.transactions == null) {
        return '0'
      } else {
        let sum = 0
        for (const i of this.transactions) {
          sum = sum + i.value
        }
        return ((sum).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '$& '))
      }
    },
    transactionMoneySummay: function () {
      if (this.transactions == null) {
        return '0.00'
      } else {
        let sum = 0
        for (const i of this.transactions) {
          sum = sum + i.sum
        }
        return ((sum).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '$& '))
      }
    },
    topMark: function () {
      if (this.transactions == null) {
        return 'Н/Д'
      } else {
        const marks = this.transactions.map(c => c.serviceType)
        const reps = marks.reduce((accum, item) => {
          const newCount = (accum[item] || 0) + 1
          return { ...accum, [item]: newCount }
        }, {})
        const maxTimes = Math.max.apply(null, Object.values(reps))
        const recordItem = Object.entries(reps).find(([, val]) => val === maxTimes)
        // eslint-disable-next-line eqeqeq
        if (recordItem != undefined) {
          return recordItem[0]
        } else {
          return 'Н/Д'
        }
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    upload: function (newValue, oldValue) {
      if (newValue === false && oldValue === true) {
        this.UpdateData()
      }
    }
  },
  methods: {
    ...mapActions('transactions', {
      getPetrolTransactions: 'getPetrolTransactions',
      clearData: 'clearData',
      getOpti24Transaction: 'getOpti24Transaction',
      getShellTransaction: 'getShellTransaction',
      getNesteTransaction: 'getNesteTransaction',
      getRosneftTransaction: 'getRosneftTransaction',
      uploadOpti24TransactionToServer: 'uploadOpti24TransactionToServer',
      uploadShellTransactionToServer: 'uploadShellTransactionToServer',
      uploadNesteTransactionToServer: 'uploadNesteTransactionToServer',
      uploadRosneftTransactionToServer: 'uploadRosneftTransactionToServer'
    }),
    ...mapActions({
      successAlert: 'alert/success',
      warningAlert: 'alert/warning'
    }),
    async onLoadDialogClosed (result) {
      this.isLoadingDialog = false
      this.isLoading = true
      switch (result.cardSystem) {
        case 'Опти-24':
          this.uploadOpti24TransactionToServer(this.uploadFile)
          break
        case 'Shell':
          this.uploadShellTransactionToServer(this.uploadFile)
          break
        case 'Neste Oil':
          this.uploadNesteTransactionToServer(this.uploadFile)
          break
        case 'Роснефть':
          this.uploadRosneftTransactionToServer(this.uploadFile)
      }
      setTimeout(() => {
        this.isLoading = false
      }, 5000)
    },
    OnDrop (formData, files) {
      if (files.length > 1) {
        this.warningAlert('Невозможно загрузить несколько файлов')
      } else {
        this.isLoadingDialog = true
        this.uploadFile = files[0]
      }
    },
    onCardSystemChanged (item) {
      this.UpdateData()
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    getPetrolTransaction (token, date) {
      const currentDate = new Date(date)
      this.getPetrolTransactions({ date: currentDate, token: token })
    },
    NextMonth () {
      const currentDate = new Date(this.mainDate)
      currentDate.setMonth(currentDate.getMonth() + 1)
      this.mainDate = currentDate
      this.mainDateText = this.mainDate.toLocaleString('ru', { month: 'long', year: 'numeric' })
      this.UpdateData()
    },
    PrevMonth () {
      const currentDate = new Date(this.mainDate)
      currentDate.setMonth(currentDate.getMonth() - 1)
      this.mainDate = currentDate
      this.mainDateText = this.mainDate.toLocaleString('ru', { month: 'long', year: 'numeric' })
      this.UpdateData()
    },
    UpdateData () {
      // 'DGTgaaGbTbEvCFygnFuLXXHXXdxcLGUR'
      this.clearData()
      switch (this.cardSystem) {
        case 'ППР':
          if (this.user.petrolToken) {
            this.getPetrolTransaction(this.user.petrolToken, this.mainDate)
          } else {
            this.getPetrolTransaction(localStorage.getItem('petrolToken'), this.mainDate)
          }
          break
        case 'Shell':
          this.getShellTransaction(this.mainDate)
          break
        case 'Neste Oil':
          this.getNesteTransaction(this.mainDate)
          break
        case 'Опти24':
          this.getOpti24Transaction(this.mainDate)
          break
        case 'Роснефть':
          this.getRosneftTransaction(this.mainDate)
          break
      }
    }
  },
  components: {
    TransactionsBarChart,
    StatisticBar,
    RateBarChart,
    VueFullScreenFileDrop,
    ReportDragAndDrop,
    ReportLoadForm
  },
  data: () => ({
    cardSystem: 'ППР',
    cardSystems: ['ППР', 'Опти24', 'Shell', 'Neste Oil', 'Роснефть'],
    mainDateText: '-',
    uploadFile: null,
    isLoading: false,
    isLoadingDialog: false,
    mainDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    headers: [
      {
        text: 'Бренд АЗС',
        align: 'start',
        sortable: false,
        value: 'brand',
        group: true
      },
      { text: 'Номер карты', value: 'cardNumber', groupable: true },
      { text: 'Дата/Время', value: 'transactionDateTime', groupable: false },
      { text: 'Марка топлива', value: 'serviceType', groupable: false },
      { text: 'Заправлено', value: 'value', groupable: false },
      { text: 'Сумма (руб.)', value: 'sum', groupable: false }
    ],
    window: {
      width: 0,
      height: 0
    }
  }),
  mounted () {
    document.title = 'Рабочий стол - ATK Web'
    this.cardSystem = this.cardSystem = localStorage.getItem('defaultCardSystem') ? localStorage.getItem('defaultCardSystem') : 'ППР'
    this.UpdateData()
    this.mainDateText = this.mainDate.toLocaleString('ru', { month: 'long', year: 'numeric' })
  }
}
</script>
<style scoped>
.custom-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  /* background-color: #FF8C8C; */
  color: whitesmoke;
  font-size: 2.8em;
}
.custom-content:before {
  border: 5px dashed gray;
  /* border: 5px dashed #414244; */
  content: "";
  bottom: 60px;
  left: 60px;
  position: absolute;
  right: 60px;
  top: 60px;
}
.table-container {
  min-width: 272px;
  max-width: 100%;
  width:100%;
  box-sizing: content-box;
}

table {
  width: 100%;
  padding: 0;
}

table td, table th {
  padding: 5px;
  margin: 5px;
}

@media (max-width: 720px) {

  .table-container table thead {
    display: none;
  }

  .table-container table tr {
    display: block;

  }

  .endline{
    border: solid 2px #8a8a8a;
    padding:10px;
    border-radius: 15%;
    margin-top: 25px;
  }
  .table-container table td:first-of-type {
      border-top: solid 0px ;
  }
  /* table tr{
      border-bottom: solid 2px;
  } */
  .table-container table td {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    padding:0px;
  }

  .table-container table td::before {
    content: attr(data-label);
    white-space: pre-wrap;
    word-wrap: break-word;
    font-weight: bold;
    margin-right: 0;
  }

}

@media (max-width: 350px){
  .endline{
    border: solid 2px #8a8a8a;
    padding:5px;
    border-radius: 15%;
    margin-top: 25px;
  }

}

</style>
